export const GETPOST_REQUEST = 'GetPostReducer/GETPOST_REQUEST';
export const GETTOPPOST_REQUEST = 'GetPostReducer/GETTOPPOST_REQUEST';
export const GETPOST_SUCCESS = 'GetPostReducer/GETPOST_SUCCESS';
export const GETTOPPOST_SUCCESS = 'GetPostReducer/GETTOPPOST_SUCCESS';
export const GETTOPPOST_FAILED = 'GetPostReducer/GETTOPPOST_FAILED';
export const GETPOST_FAILED = 'GetPostReducer/GETPOST_FAILED';
export const GETDETAIL_REQUEST = 'GetDetailReducer/GETDETAIL_REQUEST';
export const GETDETAIL_SUCCESS = 'GetDetailReducer/GETDETAIL_SUCCESS';
export const GETDETAIL_FAILED = 'GetDetailReducer/GETDETAIL_FAILED';
export const GETOWNER_REQUEST = 'GetOwnerReducer/GETOWNER_REQUEST';
export const GETOWNER_SUCCESS = 'GetOwnerReducer/GETOWNER_SUCCESS';
export const GETOWNER_FAILED = 'GetOwnerReducer/GETOWNER_FAILED';
export const GETAPPLICANTS_REQUEST = 'GetApplicantReducer/GETAPPLICANTS_REQUEST';
export const GETAPPLICANTS_SUCCESS = 'GetApplicantReducer/GETAPPLICANTS_SUCCESS';
export const GETAPPLICANTS_FAILED = 'GetApplicantReducer/GETAPPLICANTS_FAILED';
export const PAGE_INFO = 'GetPostReducer/PAGE_INFO';